import React from 'react';

const Home = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 text-white">
      <h1 className="text-5xl font-bold mb-6">Something is Brewing</h1>
      <p className="text-lg">
        Stay tuned for something exciting! In the meantime, you can share your thoughts.
      </p>
    </div>
  );
};

export default Home;
